export default {"src":"/_next/static/media/EXC.3b79d8c5.svg","height":18,"width":18};